import { useEffect } from 'react';

const WoocommerceDownload = () => {
    useEffect(() => {
        // Redirect to actual static file URL
        window.location.href = '/plugins/plugin/woocommerce.zip';
    }, []);
    return <>
    </>;
};

export default WoocommerceDownload;
